module.exports = __webpack_public_path__ + "static/media/informed-animation.6c113e43.gif";